import { requiredTrue } from 'ngrx-forms/validation';
import { BuildValidatorDecorator } from './helpers';

export const RequiredTrue = BuildValidatorDecorator(requiredTrue, 'DX.FORMS.VALIDATION.ERRORS.REQUIRED_TRUE');
